const factorAuth = {
    'title': '解除鎖定',
    'id_no': '證件號碼(後4碼)',
    'data': '驗證欄位',
    'verification_failed': '驗證失敗',
};

export default factorAuth;
